export enum ContentType {
  YOUTUBE = 'YOUTUBE',
  TWITTER = 'TWITTER',
  INSTAGRAM = 'INSTAGRAM',
}

export type ImageCarouselItem = 'GraphImage' | 'GraphVideo'

export type BaseContentData = {
  url: string
  meta: {
    handle: string
    shortcode: string
  }
}

export type ContentData = BaseContentData & {
  meta: {
    type?: string
    items?: ImageCarouselItem[]
  }
}

export interface Content {
  id: number
  type: ContentType
  title: string
  data: ContentData
  context?: string
}
